import { render, staticRenderFns } from "./kmultiselect.vue?vue&type=template&id=e80288b2&scoped=true"
import script from "./kmultiselect.vue?vue&type=script&lang=js"
export * from "./kmultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80288b2",
  null
  
)

export default component.exports